import { c as _c } from "react/compiler-runtime";
import { QueryParams } from "@router/route-params";
import { createContext, useContext, useEffect, useState } from "react";
const UserContext = createContext(undefined);

/**
 * @returns A provider component from which children can get the logged in user object.
 */
export function UserProvider(t0) {
  const $ = _c(8);
  const {
    children,
    user
  } = t0;
  const [originUrl, setOriginUrl] = useState(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const url = new URL(window.location.href);
      const originUrl_0 = url.searchParams.get(QueryParams.settingsOriginUrl);
      if (originUrl_0) {
        setOriginUrl(originUrl_0);
        url.searchParams.delete(QueryParams.settingsOriginUrl);
        window.history.replaceState({}, "", url.toString());
      }
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== originUrl || $[3] !== user) {
    t3 = {
      user,
      originUrl
    };
    $[2] = originUrl;
    $[3] = user;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== t3) {
    t4 = <UserContext.Provider value={t3}>{children}</UserContext.Provider>;
    $[5] = children;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}

/** Hook that returns the user context */
export function useUserContext() {
  const context = useContext(UserContext);
  if (!context) {
    throw Error("useUserContext must be used inside the UserProvider");
  }
  return context;
}